import { render, staticRenderFns } from "./message-abstract-video.vue?vue&type=template&id=2897e42c&scoped=true"
import script from "./message-abstract-video.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-video.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-abstract-video.vue?vue&type=style&index=0&id=2897e42c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897e42c",
  null
  
)

export default component.exports